import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (er) {
      setErr(formatApiError(er));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--cream)] px-6">
      <div className="w-full max-w-md card-warm p-8">
        <h1 className="font-display text-3xl mb-2">Reset your password</h1>
        <p className="text-sm text-[color:var(--stone)] mb-6">Enter the email you signed up with and we&rsquo;ll send a reset link.</p>
        {sent ? (
          <div data-testid="forgot-sent" className="p-4 rounded-xl bg-[color:var(--cream-2)] text-sm">
            If that email is registered, a reset link has been sent. Please check your inbox.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="forgot-email-input" type="email" required placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full px-4 py-3 rounded-full border-2 border-[color:var(--border)] outline-none focus:border-[color:var(--ink)] bg-white" />
            {err && <div className="text-sm text-[color:var(--red)]">{err}</div>}
            <button data-testid="forgot-submit-btn" disabled={busy} className="w-full btn-pill btn-primary">{busy ? "Sending…" : "Send reset link"}</button>
          </form>
        )}
        <div className="mt-4 text-sm text-center">
          <Link data-testid="forgot-back-link" to="/login" className="text-[color:var(--stone)] hover:text-[color:var(--ink)]">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
